import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import treeTransfer from 'el-tree-transfer';
import { delEntityAdjust, getEditAdjust, getEntityEditAdjust, getEntityMoneyAdjustCustomer, getEntityMoneyAdjustList, getEntityMoneyTypes, setEntityMoneyAdjust, getBlackList, addMenu } from '@/views/mallDecoration/api';
import { handChannelWarningRestrictions } from '@/api/goodsCenter';
import { deleteKnowledge } from '@/api/directoryManagement';
import { getChannelMenusType } from '@/views/channelManage/api';
export default {
  name: 'menuAdjustDrawer',
  components: {
    treeTransfer: treeTransfer
  },
  props: {
    trendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      setFormRule: {
        company_id: '',
        company_name: '',
        is_open_discount: '0',
        // 是否开启商品折扣【0不开启，1开启】
        money_type: '',
        by_ratio_adjust: '',
        is_show_line_price: '0',
        line_price_type: '2',
        is_number_comments: '0',
        number_comments: '',
        is_entity_profit_rate: '0',
        entity_profit_rate: '',
        is_keyword_blacklist: '0',
        is_show_special: '',
        is_use_special: '1',
        is_minimum_amount: '0',
        minimum_amount: '',
        keyword_blacklist: []
      },
      form: {
        company_name: '',
        money_type: '',
        by_ratio_adjust_gt: '',
        by_ratio_adjust_lt: '',
        is_show_line_price: '',
        number_comments_gt: '',
        number_comments_lt: '',
        entity_profit_rate_gt: '',
        entity_profit_rate_lt: '',
        is_show_special: '',
        page: 1,
        pagesize: 20
      },
      keyword: '',
      category_id: '',
      moneyTypes: [],
      sellUserList: [],
      dataList: [],
      pages: {},
      dialogVisible: false,
      adjustTitle: '',
      total_count: 0,
      adjustType: '',
      menuList: [],
      disabledMenuList: [],
      warning_restrictions: 0 // 折扣预警值
    };
  },
  mounted: function mounted() {
    this.getType();
    this.getData();
    this.getChannelWarningRestrictions();
  },
  methods: {
    deleteKnowledge: deleteKnowledge,
    // 获取折扣预警
    getChannelWarningRestrictions: function getChannelWarningRestrictions() {
      var _this = this;
      handChannelWarningRestrictions().then(function (res) {
        _this.warning_restrictions = Number(res.data.warning_restrictions);
      });
    },
    getType: function getType() {
      var _this2 = this;
      getEntityMoneyTypes().then(function (res) {
        _this2.moneyTypes = res.data.data;
      });
    },
    getData: function getData() {
      var _this3 = this;
      var params = this.form;
      params.category_id = this.trendParams.category_id;
      if (this.trendParams && this.trendParams.company_name) {
        params.company_name = this.trendParams.company_name;
      }
      getEntityMoneyAdjustList(params).then(function (res) {
        _this3.dataList = res.data.data.data;
        _this3.pages = res.data.page;
      });
    },
    search: function search() {
      this.form.page = 1;
      this.getData();
    },
    createAdjust: function createAdjust(type, row) {
      this.adjustTitle = type === 'add' ? '添加客户规则' : '修改客户规则';
      this.adjustType = type;
      this.dialogVisible = true;
      if (type === 'add') {
        this.getCompany();
        this.getBlackMenuList(0);
      } else if (type === 'edit') {
        this.getEdit(row);
        this.getBlackMenuList(row.rule_id);
      }
    },
    // 查看日志
    goLog: function goLog() {
      var src = '';
      src = "".concat(this.$store.state.user.domainName, "/#/mallDecoration/menuAdjustLogList?category_id=").concat(this.trendParams.category_id);
      window.open(src, '_blank');
    },
    remoteMethodCompany: function remoteMethodCompany(val) {
      console.log(val);
      this.getCompany(val);
    },
    getCompany: function getCompany(val) {
      var _this4 = this;
      var params = {
        category_id: this.trendParams.category_id,
        name: val
      };
      getEntityMoneyAdjustCustomer(params).then(function (res) {
        _this4.sellUserList = res.data.list;
      });
    },
    getEdit: function getEdit(row) {
      var _this5 = this;
      var params = {
        rule_id: row.rule_id
      };
      getEntityEditAdjust(params).then(function (res) {
        _this5.setFormRule = res.data.data;
      });
    },
    delAdjust: function delAdjust(row) {
      var _this6 = this;
      this.$confirm('您确定删除本条客户规则吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          rule_id: row.rule_id
        };
        delEntityAdjust(params).then(function (res) {
          _this6.$message.success('删除成功');
          _this6.getData();
        });
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    save: function save() {
      var _this7 = this;
      if (this.setFormRule.is_keyword_blacklist === '1' && this.setFormRule.keyword_blacklist.length === 0) {
        this.$message.error('请填写黑名单关键词');
        return false;
      }
      this.$refs.setFormRule.validate(function (valid) {
        if (valid) {
          var params = _this7.setFormRule;
          params.type = _this7.adjustType;
          params.category_id = _this7.trendParams.category_id;
          var leafIds = _this7.getLeafIds(_this7.disabledMenuList);
          params['blacklist_custom_cat_id'] = leafIds.length == 0 ? null : leafIds;
          setEntityMoneyAdjust(params).then(function () {
            _this7.setFormRule.page = 1;
            _this7.getData();
            _this7.handleClose();
          });
        }
      });
    },
    // 递归获取数组中所有“最后一级”节点的 id（无 _child 或 _child 为空）
    getLeafIds: function getLeafIds(arr) {
      var ids = [];
      if (!Array.isArray(arr)) return ids;
      var _dfs = function dfs(nodes) {
        var _iterator = _createForOfIteratorHelper(nodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var n = _step.value;
            if (!n._child || !Array.isArray(n._child) || n._child.length === 0) {
              if (n.id !== undefined) ids.push(n.id);
            } else {
              _dfs(n._child);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };
      _dfs(arr);
      return ids;
    },
    saveKey: function saveKey() {
      if (this.keyword) {
        this.setFormRule.keyword_blacklist.push(this.keyword);
        this.keyword = '';
      } else {
        this.$message.error('请填写黑名单关键词');
      }
    },
    deleteKey: function deleteKey(index) {
      this.setFormRule.keyword_blacklist.splice(index, 1);
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      delete this.setFormRule.rule_id;
      // this.$refs.setFormRule.resetFields();
      this.setFormRule = {
        company_id: '',
        company_name: '',
        is_open_discount: '0',
        // 是否开启商品折扣【0不开启，1开启】
        money_type: '',
        by_ratio_adjust: '',
        is_show_line_price: '0',
        is_number_comments: '0',
        number_comments: '',
        is_entity_profit_rate: '0',
        entity_profit_rate: '',
        is_keyword_blacklist: '0',
        keyword_blacklist: []
      };
    },
    channelDataPage: function channelDataPage(val) {
      this.form.page = val;
      this.getData();
    },
    sizeChange: function sizeChange(size) {
      this.form.pagesize = size;
      this.form.page = 1;
      this.getData();
    },
    getBlackMenuList: function getBlackMenuList(rule_id) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, res, _convertPidToNumber;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                rule_id: rule_id,
                category_id: _this8.trendParams.category_id
              };
              _context.n = 1;
              return getBlackList(params);
            case 1:
              res = _context.v;
              // 递归将数组中每个项的 pid 转为数字（若无法转换则保留原值），并处理 _child 子节点
              _convertPidToNumber = function convertPidToNumber(arr) {
                if (!Array.isArray(arr)) return [];
                return arr.map(function (item) {
                  // 浅拷贝，避免直接修改返回的原始对象（按需可直接修改）
                  var newItem = _objectSpread({}, item);
                  // 将 pid 尝试转为数字
                  var n = Number(newItem.pid);
                  newItem.pid = Number.isNaN(n) ? newItem.pid : n;
                  // 同时将 id 尝试转为数字
                  var idn = Number(newItem.id);
                  newItem.id = Number.isNaN(idn) ? newItem.id : idn;
                  // 递归处理子节点（后端可能使用 _child 存子节点）
                  if (newItem._child && Array.isArray(newItem._child)) {
                    newItem._child = _convertPidToNumber(newItem._child);
                  }
                  return newItem;
                });
              };
              _this8.disabledMenuList = _convertPidToNumber(res.data.yes_select);
              _this8.menuList = _convertPidToNumber(res.data.no_select);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};